// extracted by mini-css-extract-plugin
module.exports = {"section":"_3M4e6JWt_1tKpG2skUA5cl","heading":"_1VmsC9F7dtXl9zaG2cTGy4","content":"_1QK_ATvBDJ8paN4izjo3Le","no-padding":"_1qMCNvC6zSX5vxX7E6G15H"};